import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "block__title" }

import { LabData } from '@/types/LabData';
import LabsCategoryCard from './CategoryCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Category',
  props: {
    categories: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_TransitionGroup, {
      tag: "div",
      name: "fade",
      class: "category"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (card, index) => {
          return (_openBlock(), _createBlock(LabsCategoryCard, {
            key: `CategoryCard${index}`,
            card: card
          }, null, 8, ["card"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})